import React, { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import {
  Button,
  makeStyles,
  TableFooter,
  TableCell,
  TableRow,
  CircularProgress,
} from "@material-ui/core";
import { Pagination } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import {
  DropdownCustomToggler,
  DropdownMenu4,
} from "../../_metronic/_partials/dropdowns";
import { ProgressBar, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import Moment from "moment";
import { getLicenseBuyList, getDetailContact } from "../modules/api";
import MUIDataTable from "mui-datatables";
import NumberFormat from "react-number-format";

export function LicenseBuyMng() {
  const [isShow, setIsShow] = useState(false);
  const [licenseBuyList, setLicenseBuyList] = useState([]);
  const [licenseReqDetail, setLicenseReqDetail] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [companyName, setCompanyName] = useState();

  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    centeredHeader: {
      "& span": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 15,
        fontWeight: "bold",
      },
    },
  }));

  const classes = useStyles();

  const fetchData = async () => {
    try {
      const result = await getLicenseBuyList();
      console.log("getLicenseBuyList", result);

      let list = [];

      result.data.map((data, index) => {
        if (data.deletedAt === null) {
          var obj = new Object();
          obj.idx = result.data.length - index;
          obj.no = data.no;
          obj.botCount = data.botAmount + " Bot";
          obj.term = data.term + "년";
          obj.price = (
            <NumberFormat
              value={data.price}
              displayType={"text"}
              thousandSeparator={true}
              renderText={(value) => <div>{value}원</div>}
            />
          );
          obj.licenseNumber = data.licenseHistory.licenseNumber;
          obj.buyType = data.type === "new" ? "구매" : "재구매";

          obj.paidAt = data.paidAt
            ? Moment(data.paidAt).format("YYYY-MM-DD")
            : "-";

          list.push(obj);
        }
      });

      setLicenseBuyList(list);
    } catch (e) {
      console.log(e);
      // Handle error
    }
  };

  useEffect(() => {
    setListLoading(true);
    setTimeout(async () => {
      fetchData();
      setListLoading(false);
    }, 1000);
  }, []);

  const columns = [
    {
      name: "idx",
      label: "번호",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "no",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "botCount",
      label: "Bot수",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "term",
      label: "사용기간",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "price",
      label: "금액",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "licenseNumber",
      label: "라이선스",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "buyType",
      label: "구매분류",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },

    {
      name: "paidAt",
      label: "구매일",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
  ];

  const options = {
    print: false,
    download: false,
    rowsPerPage: 15,
    rowsPerPageOptions: [],
    filter: false,
    viewColumns: false,
    selectToolbarPlacement: "none",
    selectableRows: "none",

    textLabels: {
      body: {
        noMatch: listLoading ? (
          <CircularProgress size={25} color={"inherit"} />
        ) : licenseBuyList ? (
          ""
        ) : (
          "검색 결과가 없습니다."
        ),
      },
    },
  };

  return (
    <div id="pageid31">
      <div style={{ marginTop: 30 }}>
        <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
          라이선스 구매 관리
        </h3>
      </div>

      <div className="gutter-b" style={{ marginTop: 50 }}>
        <div className="table-responsive">
          <MUIDataTable
            // title={"Bot 관리"}
            data={licenseBuyList}
            columns={columns}
            options={options}
          />
        </div>
      </div>
    </div>
  );
}
export default LicenseBuyMng;
